module.exports = __webpack_public_path__ + "img/quadTree.36c01e23.gif";